export default __webpack_public_path__ + "static/media/3.f553510e.svg";